import { TagCloudTargetingsState, TagValue, TargetingTagValue } from '../typings/tagCloudTargeting';

export const OPEN_TAG_CLOUD_TARGETING = 'OPEN_TAG_CLOUD_TARGETING';
export type OPEN_TAG_CLOUD_TARGETING = typeof OPEN_TAG_CLOUD_TARGETING;

export interface TagCloudTargetingOpenAction {
    type: OPEN_TAG_CLOUD_TARGETING;
    editorId: string;
}

export const openTagCloudTargeting = (editorId: string): TagCloudTargetingOpenAction => {
    return {
        type: OPEN_TAG_CLOUD_TARGETING,
        editorId
    };
};

export const CLOSE_TAG_CLOUD_TARGETING = 'CLOSE_TAG_CLOUD_TARGETING';
export type CLOSE_TAG_CLOUD_TARGETING = typeof CLOSE_TAG_CLOUD_TARGETING;

export interface TagCloudTargetingCloseAction {
    type: CLOSE_TAG_CLOUD_TARGETING;
    editorId: string;
}

export const closeTagCloudTargeting = (editorId: string): TagCloudTargetingCloseAction => {
    return {
        type: CLOSE_TAG_CLOUD_TARGETING,
        editorId
    };
};

export const SAVE_TAG_CLOUD_TARGETING = 'SAVE_TAG_CLOUD_TARGETING';
export type SAVE_TAG_CLOUD_TARGETING = typeof SAVE_TAG_CLOUD_TARGETING;

export interface TagCloudTargetingSaveAction {
    type: SAVE_TAG_CLOUD_TARGETING;
    editorId: string;
    onTargetingSave?: (value: TargetingTagValue[]) => TargetingTagValue[];
}

export const saveTagCloudTargeting = (
    editorId: string,
    onTargetingSave?: (value: TargetingTagValue[]) => TargetingTagValue[]
): TagCloudTargetingSaveAction => {
    return {
        type: SAVE_TAG_CLOUD_TARGETING,
        editorId,
        onTargetingSave
    };
};

export const CHANGE_TAG_IN_TAG_CLOUD_TARGETING = 'CHANGE_TAG_IN_TAG_CLOUD_TARGETING';
export type CHANGE_TAG_IN_TAG_CLOUD_TARGETING = typeof CHANGE_TAG_IN_TAG_CLOUD_TARGETING;

export interface TagInTagCloudTargetingChangeAction {
    type: CHANGE_TAG_IN_TAG_CLOUD_TARGETING;
    editorId: string;
    tag: TargetingTagValue;
    newValue: TagValue;
    canHaveBothTargetingModes: boolean;
    getInternalValueFromUserInput?: (tag: TagValue) => TagValue;
}

export const changeTagInTagCloudTargeting = (
    editorId: string,
    tag: TargetingTagValue,
    newValue: TagValue,
    canHaveBothTargetingModes: boolean,
    getInternalValueFromUserInput?: (tag: TagValue) => TagValue
): TagInTagCloudTargetingChangeAction => {
    return {
        type: CHANGE_TAG_IN_TAG_CLOUD_TARGETING,
        editorId,
        tag,
        newValue,
        canHaveBothTargetingModes,
        getInternalValueFromUserInput
    };
};

export const ADD_TAGS_IN_TAG_CLOUD_TARGETING = 'ADD_TAGS_IN_TAG_CLOUD_TARGETING';
export type ADD_TAGS_IN_TAG_CLOUD_TARGETING = typeof ADD_TAGS_IN_TAG_CLOUD_TARGETING;

export interface TagsInTagCloudTargetingAddAction {
    type: ADD_TAGS_IN_TAG_CLOUD_TARGETING;
    editorId: string;
    tags: TargetingTagValue[];
    canHaveBothTargetingModes: boolean;
    getInternalValueFromUserInput?: (tag: TagValue) => TagValue;
}

export const addTagsInTagCloudTargeting = (
    editorId: string,
    tags: TargetingTagValue[],
    canHaveBothTargetingModes: boolean,
    getInternalValueFromUserInput?: (tag: TagValue) => TagValue
): TagsInTagCloudTargetingAddAction => {
    return {
        type: ADD_TAGS_IN_TAG_CLOUD_TARGETING,
        editorId,
        tags,
        canHaveBothTargetingModes,
        getInternalValueFromUserInput
    };
};

export const DELETE_TAG_IN_TAG_CLOUD_TARGETING = 'DELETE_TAG_IN_TAG_CLOUD_TARGETING';
export type DELETE_TAG_IN_TAG_CLOUD_TARGETING = typeof DELETE_TAG_IN_TAG_CLOUD_TARGETING;

export interface TagInTagCloudTargetingDeleteAction {
    type: DELETE_TAG_IN_TAG_CLOUD_TARGETING;
    editorId: string;
    tag: TargetingTagValue;
}

export const deleteTagInTagCloudTargeting = (
    editorId: string,
    tag: TargetingTagValue
): TagInTagCloudTargetingDeleteAction => {
    return {
        type: DELETE_TAG_IN_TAG_CLOUD_TARGETING,
        editorId,
        tag
    };
};

export const SOFT_DELETE_TAG_IN_TAG_CLOUD_TARGETING = 'SOFT_DELETE_TAG_IN_TAG_CLOUD_TARGETING';
export type SOFT_DELETE_TAG_IN_TAG_CLOUD_TARGETING = typeof SOFT_DELETE_TAG_IN_TAG_CLOUD_TARGETING;

export interface TagInTagCloudTargetingSoftDeleteAction {
    type: SOFT_DELETE_TAG_IN_TAG_CLOUD_TARGETING;
    editorId: string;
    tag: TargetingTagValue;
    onDelete?: () => void;
}

export const softDeleteTagInTagCloudTargeting = (
    editorId: string,
    tag: TargetingTagValue,
    onDelete?: () => void
): TagInTagCloudTargetingSoftDeleteAction => {
    return {
        type: SOFT_DELETE_TAG_IN_TAG_CLOUD_TARGETING,
        editorId,
        tag,
        onDelete
    };
};

export const LOAD_TAG_CLOUD_TARGETING = 'LOAD_TAG_CLOUD_TARGETING';
export type LOAD_TAG_CLOUD_TARGETING = typeof LOAD_TAG_CLOUD_TARGETING;

export interface TagCloudTargetingLoadAction {
    type: LOAD_TAG_CLOUD_TARGETING;
    editorId: string;
    shouldValueBeSaved: boolean;
    validateTag?: (tag: TagValue) => boolean;
    getRenderValue?: (tag: TagValue) => TagValue;
}

export const loadTagCloudTargeting = (
    editorId: string,
    shouldValueBeSaved: boolean = false,
    validateTag?: (tag: TagValue) => boolean,
    getRenderValue?: (tag: TagValue) => TagValue
): TagCloudTargetingLoadAction => {
    return {
        type: LOAD_TAG_CLOUD_TARGETING,
        editorId,
        shouldValueBeSaved,
        validateTag,
        getRenderValue
    };
};

export const UPDATE_TAG_CLOUD_TARGETINGS = 'UPDATE_TAG_CLOUD_TARGETINGS';
export type UPDATE_TAG_CLOUD_TARGETINGS = typeof UPDATE_TAG_CLOUD_TARGETINGS;

export interface TagCloudTargetingsUpdateAction {
    type: UPDATE_TAG_CLOUD_TARGETINGS;
    editors: TagCloudTargetingsState;
}

export const updateTagCloudTargetings = (editors: TagCloudTargetingsState): TagCloudTargetingsUpdateAction => {
    return {
        type: UPDATE_TAG_CLOUD_TARGETINGS,
        editors
    };
};

export type TagCloudTargetingEditorAction =
    | TagCloudTargetingOpenAction
    | TagCloudTargetingCloseAction
    | TagCloudTargetingSaveAction
    | TagInTagCloudTargetingChangeAction
    | TagInTagCloudTargetingDeleteAction
    | TagInTagCloudTargetingSoftDeleteAction
    | TagsInTagCloudTargetingAddAction
    | TagCloudTargetingLoadAction
    | TagCloudTargetingsUpdateAction;
